import type { AxiosInstance } from 'axios';

import type { AuthResponse, RefreshTokenArgs } from './types';

export class UnauthorizedApi {
  public constructor(public readonly httpClient: AxiosInstance) {}

  // Auth Methods
  public async refreshToken(args: RefreshTokenArgs): Promise<AuthResponse> {
    const response = await this.httpClient.request({
      method: 'POST',
      url: '/auth/refresh',
      data: args,
    });

    return response.data;
  }
}
